const defaultURL = 'https://parallels-2-2.loadbalancer.dicta.org.il' // note NO "path" here

export default {
  apiTrafficManager: process.env.VUE_APP_BACKEND_URL || defaultURL,
  synopsisApiTrafficManager: 'https://synopsis-2-4.loadbalancer.dicta.org.il',
  // note: once the version of synopsis --
  // where the netlify redirect for /server goes to the load balancer --
  // goes live -- change the above to 'https://synoptic.dicta.org.il/server'
}